'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagYtAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28.0002 0H0.000183105V20H28.0002V0Z", fill: "#F7F7F7" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M10.6662 5.98805C10.6662 5.62648 10.9527 5.33337 11.3298 5.33337H16.6693C17.0358 5.33337 17.3329 5.63721 17.3329 5.98805V12.6787C17.3329 13.0403 17.0419 13.3439 16.6654 13.3746C16.6654 13.3746 14.6662 13.3334 13.9995 14.5874C13.3329 13.3334 11.3336 13.3746 11.3336 13.3746C10.965 13.3518 10.6662 13.0295 10.6662 12.6787V5.98805Z",
          fill: "#D8D8D8"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M17.3329 5.33337H10.6662V9.33337H17.3329V5.33337Z", fill: "black" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.3329 5.33337H10.6662V9.33337H17.3329V5.33337Z",
          fill: "#1B2CA9"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M17.3329 9.33337H10.6662V14.6667H17.3329V9.33337Z", fill: "black" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.3329 9.33337H10.6662V14.6667H17.3329V9.33337Z",
          fill: "#E6402C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.0523 6.30111V5.68302L20.667 5.33333C20.667 5.33333 20.0602 4.59188 20.3602 4.59188C20.7268 4.59188 22.2658 5.07994 22.667 5.33333C23.0682 5.58673 23.2716 5.89126 23.3281 6.46631C23.3845 7.04136 22.9068 7.77507 22.9068 7.77507L22.667 8.33301L23.7178 8.0953C23.7178 8.0953 23.8879 9.19663 23.1144 10C22.3408 10.8034 21.2553 10.6527 21.2553 10.6527L21.037 10C21.037 10 20.3285 10.2752 19.9118 10.8988C19.4951 11.5225 19.3776 12.6003 20.0523 13.2656C20.7271 13.9309 21.8404 13.8745 22.3712 12.9392C22.3712 12.9392 22.5842 12.112 22.0934 11.7231C21.6026 11.3341 21.2704 12.1377 21.2553 12.0934C21.16 11.8129 21.037 11.3341 21.8257 11.3341C22.6144 11.3341 23.0202 12.1822 22.9068 12.8342C22.7933 13.4862 22.5657 14.1053 21.037 14.2789C19.5082 14.4525 19.1148 12.5148 19.1148 12.5148C19.1148 12.5148 18.7251 10.7066 19.1148 9.40096C19.5044 8.0953 20.082 8.06291 21.2553 7.34603C22.4286 6.62915 20.547 7.10295 20.547 7.10295C20.547 7.10295 19.6534 7.77507 19.3733 7.53044C19.0932 7.28581 20.0523 6.30111 20.0523 6.30111Z",
          fill: "#D0D0D0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M21.0002 7.66669C21.7366 7.66669 22.3335 7.06973 22.3335 6.33335C22.3335 5.59697 21.7366 5.00002 21.0002 5.00002C20.2638 5.00002 19.6668 5.59697 19.6668 6.33335C19.6668 7.06973 20.2638 7.66669 21.0002 7.66669Z",
          fill: "#262626",
          fillOpacity: 0.3
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.94802 6.30111V5.68302L7.33335 5.33333C7.33335 5.33333 7.94021 4.59188 7.64016 4.59188C7.27354 4.59188 5.73456 5.07994 5.33335 5.33333C4.93214 5.58673 4.72877 5.89126 4.6723 6.46631C4.61584 7.04136 5.09361 7.77507 5.09361 7.77507L5.33335 8.33301L4.28257 8.0953C4.28257 8.0953 4.11245 9.19663 4.88601 10C5.65957 10.8034 6.74506 10.6527 6.74506 10.6527L6.9634 10C6.9634 10 7.6719 10.2752 8.08856 10.8988C8.50523 11.5225 8.62272 12.6003 7.94802 13.2656C7.27331 13.9309 6.16001 13.8745 5.62917 12.9392C5.62917 12.9392 5.4162 12.112 5.907 11.7231C6.39781 11.3341 6.73001 12.1377 6.74506 12.0934C6.84039 11.8129 6.9634 11.3341 6.17466 11.3341C5.38593 11.3341 4.98016 12.1822 5.09361 12.8342C5.20705 13.4862 5.43467 14.1053 6.9634 14.2789C8.49213 14.4525 8.8856 12.5148 8.8856 12.5148C8.8856 12.5148 9.27525 10.7066 8.8856 9.40096C8.49595 8.0953 7.9184 8.06291 6.74506 7.34603C5.57172 6.62915 7.45339 7.10295 7.45339 7.10295C7.45339 7.10295 8.34694 7.77507 8.62706 7.53044C8.90717 7.28581 7.94802 6.30111 7.94802 6.30111Z",
          fill: "#D0D0D0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7.00018 7.66669C6.2638 7.66669 5.66685 7.06973 5.66685 6.33335C5.66685 5.59697 6.2638 5.00002 7.00018 5.00002C7.73656 5.00002 8.33352 5.59697 8.33352 6.33335C8.33352 7.06973 7.73656 7.66669 7.00018 7.66669Z",
          fill: "#262626",
          fillOpacity: 0.3
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.8452 6.66667C12.7318 6.86278 12.6669 7.09048 12.6669 7.33333C12.6669 8.06971 13.2638 8.66667 14.0002 8.66667C14.7366 8.66667 15.3335 8.06971 15.3335 7.33333C15.3335 7.09048 15.2686 6.86278 15.1551 6.66667C14.9246 7.0652 14.4937 7.33333 14.0002 7.33333C13.5067 7.33333 13.0758 7.0652 12.8452 6.66667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.6669 12C12.2987 12 12.0002 11.7015 12.0002 11.3333C12.0002 10.9651 12.2987 10.6667 12.6669 10.6667C13.035 10.6667 13.3335 10.9651 13.3335 11.3333C13.3335 11.7015 13.035 12 12.6669 12ZM15.3335 12C14.9653 12 14.6669 11.7015 14.6669 11.3333C14.6669 10.9651 14.9653 10.6667 15.3335 10.6667C15.7017 10.6667 16.0002 10.9651 16.0002 11.3333C16.0002 11.7015 15.7017 12 15.3335 12Z",
          fill: "#F7E04B"
        }
      )
    ]
  }
);
const VpFlagYtAsset = forwardRef(FlagYtAsset);

export { VpFlagYtAsset as default };
